export default __webpack_public_path__ + "static/media/FirstBeraterBadge.76f95b85.png";